import React, { useState, useContext, useEffect } from 'react'
import { motion } from 'framer-motion'

import Barcode from 'react-barcode';
import TextArea from '../TextArea';
import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Input from '../Input'
import Select from '../Select';
import { MarkContext } from '../../context/mark'
import { ProductsContext } from '../../context/products'
import { CategorysContext } from '../../context/categorys'
import { ToastContainer, toast } from 'react-toastify';
import deletIcon from '../../images/png/deleteIcon.png'
import Lottie from 'react-lottie';
import animation from '../../images/animated/Animation - 1736909631947.json'

const CardInput = styled.section`

    display: flex;
    width: 90%;
    margin: 0 auto;
    margin-bottom: 0.9em;


    input,select{
        width: 100%;
        height: 50px;
        border-radius: 10px;
    }

    div > label{
        font-size: 0.9rem;
    }

    .textPrimary{
        color: black;
        font-family: "Poppins";
        font-weight: 500;
        margin-bottom: 0rem;
        font-size: 1.2rem;
    }

    div{
        margin-left:1.5rem;
    }

    @media screen and (max-width:720px){
        flex-direction: column;
        div{
            margin-left: 0rem;
        }

    }


`
const CardWrapper = styled.section`
    display: flex;
    flex-direction: column;


`
const CardBarCode = styled.div`

    display: flex;
    justify-content: center;
    align-items: center;

`
const ContainerTextArea = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-bottom: 0.9rem;

`
const CardTextArea = styled.div`
    width: 85%;
    margin: 0 auto;

`
const CardImagesPreview = styled.div`

    padding:1.4rem;
    display: flex;
    width: 90%;
    overflow-x: auto;

`
const CardImage = styled.div`
    position: relative;
    .delete_icon{
        object-fit: contain;
        cursor: pointer;
        position: absolute;
        top: -28%;
        left: 0;
        width: 19px;
        height:19px;
    }


`
const ImagePreview = styled.img`
    margin-top: 1.1rem;
    object-fit: contain;
    width: 60px;
    height: 60px;
    border-radius: 100px;
    margin-right: 0.9rem;
    box-shadow: 0 0 5px black;

`
const CardDataSheet = styled.div`
    padding: 1.5rem;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 70%;
    height: 70%;
    margin: 0 auto;
    border: 1px solid #dddddd;
    border-radius: 5px;
    margin-bottom: 1.2rem;


`
const InputDataSheet = styled.input`
    font-family: "Poppins";
    font-weight: 500;
    appearance: none;
    font-size: 1rem;
    color: black;
    padding-left: 0.4rem;
    width: 420px;
    margin-bottom: 0.9rem;
    height: 45px;
    border:1px solid rgb(215, 215, 215);
    outline:none;
    border-radius: 5px;

    @media screen and (max-width:720px){
        width: 97%;
    }


`
const ContainerCardDataSheet = styled.div`

    p{
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 100px;
        width: 20px;
        height: 20px;
        color: white;
        right: 80%;
        top: -5%;

        position: absolute;
        background-color: black;
    }

    position: relative;

    .delete_icon_datasheet{
        background: white;
        cursor: pointer;
        top: -5%;
        left: 80%;
        position: absolute;
        width: 19px;
        height: 19px;
        object-fit: contain;
    }


`

const ModalProduct = ({ props }) => {

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    }

    const { marks } = useContext(MarkContext)
    const { storageProduct } = useContext(ProductsContext)
    const { categorys, subCategorys } = useContext(CategorysContext)

    const [imagesFirebase,setImagesFirebase] = useState([])
    const [selectTypeStock, setSelectTypeStock] = useState()
    const [barCodePreview, setBarCodePreview] = useState()

    
    const hasEmptyFields = (product) => {
        return Object.values(product).some(value => value === "");
    };
    
    const [product] = useState([

        {
            name: "",
            type_product: "",
            mark_product: "",
            type_stock: "",
            qtd_stock: "",
            category_product:"",
            sub_category_product:"",
            session_product:"",
            type_shippment_product:"",
            sku:"",
            bar_code:"",
            weight:"",
            lenght:"",
            width:"",
            height:"",

        }

    ])
    const [imagesPreview, setImagesPreview] = useState([])
    const [dataSheet, setDatasheet] = useState([])


    const [typeProduct] = useState([
        {
            value: "Físico"
        },
        {
            value: "Digital"
        },

    ])
    const [typeStock] = useState([
        {
            value: "Sob Encomenda"
        },
        {
            value: "Pronta Entrega"
        },

    ])
    const [typeSession] = useState([

        {
            "name": "Produtos em destaque",
        },
        {
            "name": "Engates Com Rabicho Fixo",
        },
        {
            "name": "Engates Com Rabicho Removível",
        },
        {
            "name": "Acessórios para carretinha",
        },


    ])
    const [freeShipping] = useState([
        {
            name: "Sim"
        },
        {
            name: "Não"
        }
    ])

    const [marksData] = useState([
        {
            name:"BRACONI"
        },
        {
            name:"KARRETAS"
        }
    ])

    const handleInput = (name, value) => {

        product[0][name] = value

    }
    const handleImage = (file) => {

        if (file) {

            const { type } = file

            const supportedTypes = ["image/png", "image/jpg", "image/jpeg"]
            const verifySupportedType = supportedTypes.includes(type)


            if (!verifySupportedType) {
                return toast.error("Formato de imagem não suportado!")
            }

            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = async () => {

                setImagesPreview([...imagesPreview, reader.result])
                setImagesFirebase([...imagesFirebase, file])
                // console.log(imagesFirebase)
            }

        }

    }
    const handleRemoveImage = (index) => {

        const updateImages = [...imagesPreview]
        updateImages.splice(index, 1)
        setImagesPreview(updateImages)

    }
    const handleUpdateDataSheet = async (index, name_input, value) => {

        dataSheet[index][name_input] = value
        setDatasheet([...dataSheet])

    }
    const handleNewDataSheet = async () => {
        const newDataSheet =
        {
            name: "",
            value: ""
        }
        setDatasheet([...dataSheet, newDataSheet])
    }
    const handleRemoveDataSheet = (index) => {

        const update = [...dataSheet]
        update.splice(index, 1)
        setDatasheet(update)

    }
    const handleStorage = () =>{
        if (hasEmptyFields(product[0])) {
            return toast.error("Existem campos vazios no produto!",{
                autoClose:1500
            })
        } 
        props.onHide()
        storageProduct(product[0],dataSheet,imagesFirebase)
    }


    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <CardWrapper>

                    <CardInput>
                        <div style={{ width: "100%" }}><p className='textPrimary'>Informações iniciais</p></div>
                        <div style={{ width: "100%" }}></div>
                    </CardInput>

                    <CardInput>
                        <Input name={"Nome *"} onChange={(e) => handleInput("name", e.target.value)} />
                        <Select name={"Tipo de produto *"} onChange={(e) => handleInput("type_product", e.target.value)} target={"value"} data={typeProduct} />
                    </CardInput>

                    <CardInput>
                        <Select name={"Marca do produto *"} onChange={(e) => handleInput("mark_product", e.target.value)} target={"name"} data={marksData} />
                        <Select name={"Estoque do produto *"} onChange={(e) => { handleInput("type_stock", e.target.value); setSelectTypeStock(e.target.value) }} target={"value"} data={typeStock} />
                    </CardInput>

                    {selectTypeStock == "Sob Encomenda"

                        ?
                        <CardInput>
                            <Input name={"Quantidade *"} mask="99999999999" onChange={(e) => handleInput("qtd_stock", e.target.value)} />

                        </CardInput>

                        :

                        selectTypeStock != undefined
                            ?
                            <CardInput>
                                <Input name={"Quantidade (Pronta Entrega) *"} mask="99999999999" onChange={(e) => handleInput("qtd_stock", e.target.value)} />

                            </CardInput>
                            :
                            <></>
                    }

                    <CardInput>
                        <Select name={"Categoria do produto *"} target={"name"}  onChange={(e) => handleInput("category_product", e.target.value)} data={categorys} />
                        <Select name={"Sub Categoria do produto *"} target={"name"}  onChange={(e) => handleInput("sub_category_product", e.target.value)} data={subCategorys} />
                    </CardInput>

                    <CardInput>
                        <Select name={"Sessão do produto *"} onChange={(e) => handleInput("session_product", e.target.value)} target={"name"} data={typeSession} />
                        <Select name={"Frete Grátis *"} onChange={(e) => handleInput("type_shippment_product", e.target.value)} target={"name"} data={freeShipping} />
                    </CardInput>

                    <ContainerTextArea>
                        <CardTextArea>
                            <TextArea />
                        </CardTextArea>
                    </ContainerTextArea>


                    <CardInput>
                        <div style={{ width: "100%" }}><p className='textPrimary'>Códigos</p></div>
                        <div style={{ width: "100%" }}></div>
                    </CardInput>

                    <CardInput>
                        <Input name={"SKU *"} onChange={(e) => handleInput("sku", e.target.value)}  />
                        <Input name={"Código de barras *"} onChange={(e) => { product.barCode = e.target.value; setBarCodePreview(e.target.value);handleInput("bar_code", e.target.value) }} mask="999999999999999" />
                    </CardInput>

                    {barCodePreview

                        ?
                        <CardInput>
                            <CardBarCode>
                                <Barcode value={barCodePreview} fontSize={15} marginRight={0} marginLeft={0} />
                            </CardBarCode>
                            <div style={{ width: "100%" }}></div>

                        </CardInput>

                        :
                        <></>
                    }

                    <CardInput>
                        <div style={{ width: "100%" }}><p className='textPrimary'>Peso e dimensões</p></div>
                        <div style={{ width: "100%" }}></div>
                    </CardInput>

                    <CardInput>
                        <Input name={"Peso (KG) *"}  onChange={(e) => handleInput("weight", e.target.value)}/>
                        <Input name={"Comprimento *"}  onChange={(e) => handleInput("lenght", e.target.value)} />
                    </CardInput>

                    <CardInput>
                        <Input name={"Largura *"} onChange={(e) => handleInput("width", e.target.value)}  />
                        <Input name={"Altura *"} onChange={(e) => handleInput("height", e.target.value)} />
                    </CardInput>


                    <CardInput>
                        <div style={{ width: "100%" }}><p className='textPrimary'>Imagens</p></div>
                        <div style={{ width: "100%" }}></div>
                    </CardInput>

                    <CardInput>
                        <Input name={"Imagem *"} accept=".png, .jpg, .jpeg" type={"File"} onChange={(e) => handleImage(e.target.files[0])} />
                    </CardInput>

                    <CardInput>
                        {imagesPreview.length > 0
                            ?
                            <CardImagesPreview>
                                {imagesPreview?.map((item, index) => {
                                    return (
                                        <CardImage>
                                            <img src={deletIcon} onClick={() => handleRemoveImage(index)} className='delete_icon' />
                                            <ImagePreview src={`data:image/;base64;${item}`} />
                                        </CardImage>
                                    )
                                })}
                            </CardImagesPreview>
                            :

                            <></>

                        }

                    </CardInput>

                    <CardInput>
                        <div style={{ width: "100%" }}><p className='textPrimary'>Informações de lucro</p></div>
                        <div style={{ width: "100%" }}></div>
                    </CardInput>


                    <CardInput>
                        <div style={{ width: "100%" }}><p className='textPrimary'>Ficha Técnica</p></div>
                        <div style={{ width: "100%" }}></div>
                    </CardInput>

                    {dataSheet?.map((item, index) => {
                        var calcIndex = index
                        var totalIndex = calcIndex += 1
                        return (
                            <motion.div
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                            >
                                <ContainerCardDataSheet>
                                    <p>{totalIndex}</p>
                                    <img src={deletIcon} onClick={() => handleRemoveDataSheet(index)} className='delete_icon_datasheet' />

                                    <CardDataSheet>
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                                            <InputDataSheet placeholder='Nome *' onChange={(e) => handleUpdateDataSheet(index, "name", e.target.value)} />
                                            <InputDataSheet placeholder='Valor *' onChange={(e) => handleUpdateDataSheet(index, "value", e.target.value)} />
                                        </div>
                                    </CardDataSheet>
                                </ContainerCardDataSheet>
                            </motion.div>
                        )
                    })}


                    <CardInput>
                        <div onClick={() => handleNewDataSheet()}>
                            <Lottie options={defaultOptions}
                                isClickToPauseDisabled
                                isPaused={false}
                                height={90}
                                width={90}
                            />
                        </div>
                    </CardInput>

                </CardWrapper>

            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => handleStorage()}>Salvar</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalProduct